import ax from './ax';
import axJava from './axJava';

// 人脸
export function GetIdCardFrontUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardFrontUrl',
    method: 'post',
    data,
  });
}
// 人脸 2023.4.23 v2版
export function GetIdCardFrontUrlV2(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardFrontUrl_V2',
    method: 'post',
    data,
  });
}
// 国徽
export function GetIdCardBackUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardBackUrl',
    method: 'post',
    data,
  });
}
// 国徽 2023.4.23 v2版
export function GetIdCardBackUrlV2(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdCardBackUrl_V2',
    method: 'post',
    data,
  });
}
// 云码通人脸识别
export function YMTivingThing(data = {}) {
  return ax({
    url: '/api/OcrApi/YMTivingThing',
    method: 'post',
    data,
  });
}
// 提交身份证和活体照片
export function GetIdNameFaceServiceUrl(data = {}) {
  return ax({
    url: '/api/OcrApi/GetIdNameFaceServiceUrl',
    method: 'post',
    data,
  });
}
// 提交手持照片
export function FaceCompare(data = {}) {
  return ax({
    url: '/api/OcrApi/FaceCompare',
    method: 'post',
    data,
  });
}
// 人工审核
export function SubmitAuditAndUserImage(data = {}) {
  return ax({
    url: '/api/OcrApi/SubmitAuditAndUserImage',
    method: 'post',
    data,
  });
}
// 手写签名识别 2024.6.18
export function GetHandWriting(data = {}) {
  return ax({
    url: '/api/OcrApi/GetHandWriting',
    method: 'post',
    data,
  });
}
// 身份证过期，补录身份证
export function UploadIdCardImg(data = {}) {
  return ax({
    url: '/api/OcrApi/UploadIdCardImg',
    method: 'post',
    data,
  });
}
// 获取用户状态
export function GetUserStatus(data = {}) {
  return ax({
    url: '/api/UserInfo/GetUserStatus',
    method: 'post',
    data,
  });
}
// 获取上传图片服务路径
export function GetUpLoadImgUrl(data = {}) {
  return ax({
    url: '/api/Login/GetUpLoadImgUrl',
    method: 'post',
    data,
  });
}
// 人像识别（若未验证 第四步）
export function VerIdCardFace(data = {}) {
  return ax({
    url: '/api/Bank/VerIdCardFace',
    method: 'post',
    data,
  });
}
// 白卡大额人像失败申请人工审核
export function AuditBankElementsStatus(data = {}) {
  return ax({
    url: '/api/Bank/AuditBankElementsStatus',
    method: 'post',
    data,
  });
}
// 身份认证时提交多个人像
export function UpdateIdCardInfoFaceActive(data = {}) {
  return ax({
    url: '/api/Bank/UpdateIdCardInfoFaceActive',
    method: 'post',
    data,
  });
}
// 获取带参公众号二维码
export function GetOAQRCode(data = {}) {
  return axJava({
    url: '/api/OfficialAccount/GetOAQRCode',
    method: 'post',
    data,
  });
}
// 获取银行卡锁定信息 2023.4.25
export function GetBlackBankCardById(data = {}) {
  return ax({
    url: '/api/Bank/GetBlackBankCardById',
    method: 'post',
    data,
  });
}
// 解锁银行卡申请 2023.4.25
export function UnlockingBankCard(data = {}) {
  return ax({
    url: '/api/Bank/UnlockingBankCard',
    method: 'post',
    data,
  });
}

// 睡眠用户资料审核拒绝，返回当次提交的数据 2024.9.24
export function GetSleepUserData(data = {}) {
  return axJava({
    url: '/api/APPUser/GetSleepUserData',
    method: 'post',
    data,
  });
}

// 通过图片URL进行银行卡识别 2024.10.31
export function GetBankCardContent(data = {}) {
  return ax({
    url: '/api/OcrApi/GetBankCardContent',
    method: 'post',
    data,
  });
}

// 磁条卡验证四要素时获取手机短息验证码（若未验证 第三步）2024.10.31
export function GetVerCardMobileCode(data = {}) {
  return ax({
    url: '/api/Bank/GetVerCardMobileCode',
    method: 'post',
    data,
  });
}

// 睡眠用户资料提交 2024.11.18
export function SubmitSleepUserData(data = {}) {
  return axJava({
    url: '/api/APPUser/SubmitSleepUserData',
    method: 'post',
    data,
  });
}

// 公安比对，第三方功能使用 2026.1.8
export function PersonFaceVerify(data = {}) {
  return ax({
    url: '/api/UserInfo/PersonFaceVerify',
    method: 'post',
    data,
  });
}

// 获取公安比对信息，第三方功能使用 2026.1.8
export function GetPersonFaceVerifyMsg(data = {}) {
  return ax({
    url: '/api/UserInfo/GetPersonFaceVerifyMsg',
    method: 'post',
    data,
  });
}